package com.klantenstop.web.components

import androidx.compose.runtime.Composable
import com.klantenstop.web.utils.AnalyticsManager
import com.klantenstop.web.utils.Constants
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.browser.uri.encodeURIComponent
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private const val CATEGORY_REQUEST_SUBJECT = "Nieuwe categorie suggestie"
private const val CATEGORY_REQUEST_BODY =
    "Hallo KlantenStop team,\n\n" +
        "Ik kon de juiste categorie niet vinden.\n" +
        "Gewenste categorie: \n" +
        "Extra context (optioneel): \n\n" +
        "Bedankt!"

private val CATEGORY_REQUEST_MAILTO_HREF: String by lazy {
    val subject = encodeURIComponent(CATEGORY_REQUEST_SUBJECT)
    val body = encodeURIComponent(CATEGORY_REQUEST_BODY)
    "mailto:${Constants.SUPPORT_EMAIL}?subject=$subject&body=$body"
}

/**
 * Helper component that displays a helpful hint for users who don't find the category they're looking for.
 *
 * Shows: "Niet gevonden wat je zoekt? Laat het ons weten"
 *
 * Clicking the link:
 * - Tracks analytics event (CATEGORY_REQUEST_CTA_CLICKED)
 * - Opens email client to contact support with a pre-filled subject/body
 *
 * @param modifier Styling modifier
 * @param source Identifier for analytics segmentation (e.g. search/create/edit)
 */
@Composable
fun CategoryRequestHelper(
    modifier: Modifier = Modifier,
    source: String
) {
    // A single inline Span so both text nodes flow together and wrap naturally as a sentence.
    Span(attrs = modifier.color(MaterialColorVars.OnSurfaceVariant.value()).margin(top = 4.px).fontSize(12.px).toAttrs()) {
        Text("Niet gevonden wat je zoekt? ")

        A(
            href = CATEGORY_REQUEST_MAILTO_HREF,
            attrs = Modifier
                .color(MaterialColorVars.Primary.value())
                .onClick {
                    AnalyticsManager.trackEvent(
                        AnalyticsManager.Events.CATEGORY_REQUEST_CTA_CLICKED,
                        mapOf("source" to source)
                    )
                }
                .toAttrs {
                    attr("title", "Opent je e-mailapp met een vooraf ingevuld bericht")
                    attr("aria-label", "Laat het ons weten via e-mail; opent je e-mailapp")
                }
        ) {
            Text("Laat het ons weten")
        }
    }
}

